import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'cloud-tags',
  templateUrl: './cloud-tags.component.html'
})
export class CloudTagsComponent implements OnInit {

  items: any[] = [];
  selected: any[] = [];
  itemsByKey: any = {};
  clonedSelected: any[] = [];

  @Input() bindLabel: string;
  @Input() bindValue: string;

  @Input() disabled: boolean;

  @Input('items') set items$(value: any) {
    this.items = value;

    if (!this.bindValue) return;

    if (this.items.length) {
      this.items.forEach((item: any) => {
        let it = typeof item !== 'object' ? item : item[this.bindValue];

        this.itemsByKey[it.toString()] = item;
      });
    }

    this.cloneSelected();
  }
  @Input('selected') set selected$(value: any) {
    if (!value) return;
    this.selected = value;

    if (this.bindValue) {
      this.cloneSelected();
    } else {
      this.clonedSelected = this.selected;
    }
  }

  @Output() remove: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectedChange: EventEmitter<any[]> = new EventEmitter<any[]>();

  constructor() { }

  ngOnInit() {

  }

  cloneSelected() {
    if (!this.items.length) return;

    this.clonedSelected = this.selected.map((select: any) => {
      let sel = typeof select !== 'object' ? select : select[this.bindValue];

      return this.itemsByKey[sel];
    });
  }

  removeSelect(index) {
    if (this.disabled) return;

    this.clonedSelected.splice(index, 1);
    this.selected.splice(index, 1);
    this.selected = [...this.selected];

    this.selectedChange.emit(this.selected);

    this.remove.emit();
  }

}
